// testing
// export const API_HOSTNAME = "http://localhost:3001"
// export const SOCKET_SERVER = "http://localhost:3002"

// jam.dev
export const API_HOSTNAME = "https://app.jam.dev"
export const SOCKET_SERVER = "https://socket-server.jam.dev"
